<template>
  <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.583 3.583v.53l3.273.862c.183.049.31.214.31.403V6.5h3.738c.23 0 .416.224.416.5s-.186.5-.416.5h-.237v8.915c0 .03-.004.058-.01.085h.247c.23 0 .416.224.416.5s-.186.5-.416.5H1.084c-.23 0-.417-.224-.417-.5s.186-.5.416-.5h.427a.352.352 0 0 1-.01-.085V7.5h-.449C.84 7.5.667 7.276.667 7s.172-.5.384-.5h3.782V5.378c0-.191.13-.358.316-.404l3.434-.857V1.083c0-.23.224-.416.5-.416s.5.186.5.416h2.75c.23 0 .417.187.417.417v1.667c0 .23-.187.416-.417.416h-2.75zm0-.833h2.334v-.833H9.583v.833zm6.094 13.75a.352.352 0 0 1-.01-.085V7.5h-2.5v9h2.51zm-13.187 0h2.343v-9H2.5v8.915c0 .03-.004.058-.01.085zm4.843 0v-4.583c0-.23.15-.417.334-.417h2.666c.184 0 .334.187.334.417V16.5h1.666V5.687L9.1 4.833l-3.432.858V16.5h1.666zm.834-4.167V16.5h1.666v-4.167H8.167zM7.75 7.5c-.23 0-.417-.224-.417-.5s.187-.5.417-.5h2.589c.23 0 .416.224.416.5s-.186.5-.416.5H7.75z"
      :fill="color"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
	name: "OnsiteCourse",
	props: {
		isDarker: {
			type: Boolean,
			default() {
				return false;
			},
		},
		color: {
			type: String,
			default() {
				return this.isDarker ? '#383838' : '#ABABAB';
			},
		},
	},
};
</script>

<style scoped></style>
